import React, { useState, useEffect } from 'react';

const ASCIILogo = () => {
  const [isGlitching, setIsGlitching] = useState(false);
  const [currentLogo, setCurrentLogo] = useState(0);

  const logos = [
    `
██████╗ ███████╗██╗   ██╗███████╗██╗      ██████╗ ██████╗ ███████╗██████╗ 
██╔══██╗██╔════╝██║   ██║██╔════╝██║     ██╔═══██╗██╔══██╗██╔════╝██╔══██╗
██║  ██║█████╗  ██║   ██║█████╗  ██║     ██║   ██║██████╔╝█████╗  ██████╔╝
██║  ██║██╔══╝  ╚██╗ ██╔╝██╔══╝  ██║     ██║   ██║██╔═══╝ ██╔══╝  ██╔══██╗
██████╔╝███████╗ ╚████╔╝ ███████╗███████╗╚██████╔╝██║     ███████╗██║  ██║
╚═════╝ ╚══════╝  ╚═══╝  ╚══════╝╚══════╝ ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═╝
                                                                          
                    ███╗   ██╗ ██████╗  ██████╗ ██████╗                   
                    ████╗  ██║██╔═══██╗██╔═══██╗██╔══██╗                  
                    ██╔██╗ ██║██║   ██║██║   ██║██████╔╝                  
                    ██║╚██╗██║██║   ██║██║   ██║██╔══██╗                  
                    ██║ ╚████║╚██████╔╝╚██████╔╝██████╔╝                  
                    ╚═╝  ╚═══╝ ╚═════╝  ╚═════╝ ╚═════╝                   
                                                                          
`,
    `
██████╗ ███████╗██╗   ██╗███████╗██╗      ██████╗ ██████╗ ███████╗██████╗ 
██╔══██╗██╔════╝██║   ██║██╔════╝██║     ██╔═══██╗██╔══██╗██╔════╝██╔══██╗
██║  ██║█████╗  ██║   ██║█████╗  ██║     ██║   ██║██████╔╝█████╗  ██████╔╝
██║  ██║██╔══╝  ╚██╗ ██╔╝██╔══╝  ██║     ██║   ██║██╔═══╝ ██╔══╝  ██╔══██╗
██████╔╝███████╗ ╚████╔╝ ███████╗███████╗╚██████╔╝██║     ███████╗██║  ██║
╚═════╝ ╚══════╝  ╚═══╝  ╚══════╝╚══════╝ ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═╝
                                                                          
                    ███╗   ██╗ ██████╗  ██████╗ ██████╗                   
                    ████╗  ██║██╔═══██╗██╔═══██╗██╔══██╗                  
                    ██╔██╗ ██║██║   ██║██║   ██║██████╔╝                  
                    ██║╚██╗██║██║   ██║██║   ██║██╔══██╗                  
                    ██║ ╚████║╚██████╔╝╚██████╔╝██████╔╝                  
                    ╚═╝  ╚═══╝ ╚═════╝  ╚═════╝ ╚═════╝                   
                                                                          
`
  ];

  const corruptedLogo = `
██████╗ ███████╗██╗   ██╗███████╗██╗      ██████╗ ██████╗ ███████╗██████╗ 
██╔══██╗██╔════╝██║   ██║██╔════╝██║     ██╔═══██╗██╔══██╗██╔════╝██╔══██╗
██║  ██║█████╗  ██║   ██║█████╗  ██║     ██║   ██║██████╔╝█████╗  ██████╔╝
██║  ██║██╔══╝  ╚██╗ ██╔╝██╔══╝  ██║     ██║   ██║██╔═══╝ ██╔══╝  ██╔══██╗
██████╔╝███████╗ ╚████╔╝ ███████╗███████╗╚██████╔╝██║     ███████╗██║  ██║
╚═════╝ ╚══════╝  ╚═══╝  ╚══════╝╚══════╝ ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═╝
                                                                          
                    ███╗   ██╗ ██████╗  ██████╗ ██████╗                   
                    ████╗  ██║██╔═══██╗██╔═══██╗██╔══██╗                  
                    ██╔██╗ ██║██║   ██║██║   ██║██████╔╝                  
                    ██║╚██╗██║██║   ██║██║   ██║██╔══██╗                  
                    ██║ ╚████║╚██████╔╝╚██████╔╝██████╔╝                  
                    ╚═╝  ╚═══╝ ╚═════╝  ╚═════╝ ╚═════╝                   
                                                                          
  `;

  useEffect(() => {
    const glitchInterval = setInterval(() => {
      setIsGlitching(true);
      setTimeout(() => {
        setCurrentLogo(prev => (prev + 1) % logos?.length);
        setIsGlitching(false);
      }, 200);
    }, Math.random() * 10000 + 5000);

    return () => clearInterval(glitchInterval);
  }, [logos?.length]);

  return (
    <div className="relative">
      <pre className={`text-primary font-fira text-[7px] md:text-base leading-none select-none ${isGlitching ? 'animate-glitch text-destructive' : ''}`}>
        {isGlitching ? corruptedLogo : logos?.[currentLogo]}
      </pre>
      {isGlitching && (
        <div className="absolute inset-0 bg-destructive/10 animate-pulse"></div>
      )}
      <div className="text-center mt-4">
        <div className="text-muted-foreground font-source text-sm">
          Backend by profession → Frontend by accident → Native builds by curiosity → DevOps by passion ❤️
        </div>
        <div className="text-warning text-xs mt-4">
          [WARNING: CSS skills may vary]
        </div>
      </div>
    </div>
  );
};

export default ASCIILogo;